module.exports = __webpack_public_path__ + "img/small_whale34.a51ee1f3.jpg";